import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AutoSuggestionSelectComponent from '../../common/auto-suggestion-select/Select';
import { getNetworksList } from '../../../../redux/member/api-calls/findProvider';

export const ChooseNetwork = ({
  onChange,
  customOptions,
  value,
  inputClassName,
  id = '',
  labelText = '',
}) => {
  const dispatch = useDispatch();

  const {
    networksList,
    searchProviderParams: { Network },
    isNetworksListFetched,
  } = useSelector(({ priceCompare }) => priceCompare);

  useEffect(() => {
    if (!isNetworksListFetched) {
      dispatch(getNetworksList());
    }
  }, []);

  return (
    <AutoSuggestionSelectComponent
      options={
        customOptions !== null || customOptions !== undefined
          ? customOptions
          : networksList
      }
      onChange={onChange}
      components={{ IndicatorSeparator: () => null }}
      value={value}
      defaultValue={
        customOptions?.length > 0
          ? customOptions[0]
          : networksList?.length > 0
          ? networksList[0]
          : []
      }
      inputClassName={inputClassName}
      id={id}
      labelText={labelText}
    />
  );
};
